import classNames from 'classnames';
import { useEffect } from 'react';
import LazyLoad from 'react-lazyload';

import { Layout } from '@sravni/react-design-system/lib/Layout';
import { Space } from '@sravni/react-design-system/lib/Space';
import { Text, Heading } from '@sravni/react-design-system/lib/Typography';
import { Image } from '@sravni/react-image';
import { useBoolean } from '@sravni/react-utils';

import { ebsImagePng } from '@src/assets';
import { sendClickEbsBanner, sendOpenEbsBanner } from '@src/helpers/analyticsEvents';
import { isServer } from '@src/utils';
import { PIXEL_DISPLAY_WRAPPER_STYLES } from 'widgets/LightweightCard/ui/LightweightCard.config';

import { EbsDialogBanner } from '../EbsDialogBanner/EbsDialogBanner';

import { EbsBannerTexts } from './EbsBanner.texts';
import styles from './EsbBanner.module.scss';

const LazyPixel = () => {
  useEffect(() => {
    if (isServer) {
      return;
    }
    sendOpenEbsBanner();
  }, []);

  return null;
};

export function EbsBanner() {
  const [isShow, setShow] = useBoolean(false);

  const handleClose = () => {
    setShow.off();
  };

  const handleOpenModal = () => {
    sendClickEbsBanner();
    setShow.on();
  };

  return (
    <>
      <Layout className={classNames(styles.outsideContainer)} onClick={handleOpenModal}>
        <div className={styles.container}>
          <Space direction="column" size={4}>
            <Heading as="div" level={5} className={classNames('h-color-static-light', styles.heading)}>
              {EbsBannerTexts.heading}
            </Heading>
            <Text as="div" className={classNames('h-color-static-light', styles.subtitle)}>
              {EbsBannerTexts.description}
              <span className={styles.helper}>{EbsBannerTexts.howToDo}</span>
            </Text>
          </Space>
          <Space className={styles.imageContainer}>
            <Image src={ebsImagePng} />
          </Space>
        </div>
        <LazyLoad style={PIXEL_DISPLAY_WRAPPER_STYLES}>
          <LazyPixel />
        </LazyLoad>
      </Layout>
      <EbsDialogBanner visible={isShow} onClose={handleClose} data={undefined} onOverlayClick={handleClose} />
    </>
  );
}
